import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, unref as _unref, Teleport as _Teleport, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = { class: "!mt-0" }
const _hoisted_4 = { class: "narocanje-list" }
const _hoisted_5 = { class: "narocanje-item" }
const _hoisted_6 = { class: "narocanje-item" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "narocanje-item" }
const _hoisted_9 = { class: "flex items-center flex-col mt-2" }
const _hoisted_10 = { class: "text-gray-600" }

import { ref, onMounted, onUnmounted, Ref, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useIntersectionObserver } from '@vueuse/core'
import { phoneNumber, rawPhoneNumber } from '@/constants'
import { endView, resumeView, startView, trackClick } from '@/utils/analytics'

import SocutnoLogo from '@/components/SocutnoLogo.vue'
import Modal from '@/components/Modal.vue'
import LanguageButtonStandalonePage from '@/blocks/languageButtonStandalonePage.vue'
import ClosedBanner from '@/components/ClosedBanner.vue'
import PhotoGallery from '@/components/PhotoGallery.vue'
import Ekipa from '@/components/Ekipa.vue'
import Footer from '@/components/Footer.vue'
import Cenik from '@/articles/Cenik.vue'
import Pregledi from '@/articles/Pregledi.vue'
import Karies from '@/articles/Karies.vue'
import Ortopan from '@/articles/Ortopan.vue'
import Beljenje from '@/articles/Beljenje.vue'
import Otrosko from '@/articles/Otrosko.vue'
import Myobrace from '@/articles/Myobrace.vue'
import Invisalign from '@/articles/Invisalign.vue'
import Endodontsko from '@/articles/Endodontsko.vue'
import Parodontologija from '@/articles/Parodontologija.vue'
import Lasersko from '@/articles/Lasersko.vue'
import Frenulotomija from '@/articles/Frenulotomija.vue'
import Protetika from '@/articles/Protetika.vue'
import InjekcijskaTehnika from '@/articles/InjekcijskaTehnika.vue'
import ONas from '@/articles/ONas.vue'
import mapPinIcon from '@/icons/mapPinIcon.vue'
import mailIcon from '@/icons/mailIcon.vue'
import phoneIcon from '@/icons/phoneIcon.vue'
import calculatorIcon from '@/icons/calculatorIcon.vue'
import { preloadImages, isDevMode, isBotUserAgent } from '@/utils/utils'
import { useI18n } from 'vue-i18n'
import jsonData from '@/googlePlacesResponse.sample.json'
import { useUncover } from '@/blocks/uncover'
import Reviews from './Reviews.vue'
import WorkingHours from './WorkingHours.vue'
import Services from './Services.vue'
import MainPageBanner from './MainPageBanner.vue'
import ContactForm from './ContactForm.vue'
import SocialButtons from './SocialButtons.vue'

const PLACE_ID = 'ChIJU1Z1b9ZdZEcRs7Vuum1MXBk'
const BASE_URL = 'https://socutnozobozdravstvo.si/api/place'
const HOME_PAGE_ID = 'index'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { locale } = useI18n()
const route = useRoute()

const mounted = ref(false)
const openedModal: Ref<string | null> = ref(null)
const mountReviews = ref(false)
const mountGallery = ref(false)
const modalTransition = ref(true)
const ios26ModalCover = ref(false)

const servicesContainer: Ref<HTMLElement | null> = ref(null)
const oNasButton: Ref<HTMLElement | null> = ref(null)
const reviewsContainer: Ref<HTMLElement | null> = ref(null)
const galleryContainer: Ref<HTMLElement | null> = ref(null)
const mainPageModalCover: Ref<HTMLElement | null> = ref(null)

let secretSequence = ''
let secretSequenceTimeout: number | undefined
let modalOpenedOnRoute: string | null = null

const scrollToElement = ref('')

const googlePlacesResponse: Ref<any> = ref(null)

const adminData = ref({
    outEnabled: false,
    outStart: '',
    outEnd: '',
})

function transitionName(name: string): string {
    return isBotUserAgent() ? '' : name
}

useUncover()

onMounted(async () => {
    mounted.value = true

    window.addEventListener('popstate', handlePopState)
    handlePopState()

    setTimeout(async () => {
        if (isDevMode()) {
            console.log('Return cached Google places response')
            googlePlacesResponse.value = jsonData.result
            return
        }
        fetchReviewsFromGoogle(locale.value)
    }, 1500)

    try {
        const prefix = isDevMode() ? 'https://socutnozobozdravstvo.si' : ''
        const response = await fetch(`${prefix}/api/admin-data`)
        adminData.value = await response.json()
    } catch (error) {
        console.error('Error fetching admin data from socutno server', error)
    }

    useIntersectionObserver(reviewsContainer, ([{ isIntersecting }]) => {
        if (!isIntersecting) return
        mountReviews.value = true
    })

    useIntersectionObserver(galleryContainer, async ([{ isIntersecting }]) => {
        if (!isIntersecting) return
        mountGallery.value = true
    })

    const preloadServiceCoversObserver = useIntersectionObserver(
        servicesContainer,
        ([{ isIntersecting }]) => {
            if (!isIntersecting) return

            preloadServiceCoversObserver.stop()
            preloadImages([
                require('@/assets/covers/xray.jpg'),
                require('@/assets/covers/parodontalna.jpg'),
                require('@/assets/covers/pregledi-narrow.jpg'),
                require('@/assets/covers/myobrace.jpg'),
                require('@/assets/covers/invisalign2.webp'),
                require('@/assets/covers/opalescence.jpg'),
                require('@/assets/covers/lasersko.jpg'),
                require('@/assets/covers/frenulotomija.jpg'),
                require('@/assets/covers/protetika.jpg'),
                require('@/assets/covers/exam-boy.jpg'),
                require('@/assets/covers/kompoziti.jpg'),
            ])
        },
    )

    const oNasButtonObserver = useIntersectionObserver(oNasButton, ([{ isIntersecting }]) => {
        if (!isIntersecting) return
        oNasButtonObserver.stop()
        preloadImages([require('@/assets/covers/o-nas.jpg')])
    })
})

onUnmounted(() => window.removeEventListener('popstate', handlePopState))

async function fetchReviewsFromGoogle(language: string) {
    try {
        const apiUrl = `${BASE_URL}?placeId=${PLACE_ID}&language=${language}`
        const response = await fetch(apiUrl)
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
        }
        googlePlacesResponse.value = (await response.json()).result ?? null
    } catch (error) {
        console.error('Error fetching Google reviews:', error)
    }
}

watch(locale, async newLocale => {
    if (isDevMode()) return
    fetchReviewsFromGoogle(newLocale)
})

const handlePopState = () => {
    const modalId = window.location.hash.substring(1)

    const navigatingHome = !!modalId
    if (!navigatingHome) {
        closeModal()
        return
    }

    const alreadyOpened = modalId === openedModal.value
    if (!alreadyOpened) {
        if (!openedModal.value) {
            openModal(modalId)
        } else {
            switchModal(modalId)
        }
    }
}

function pushState(data: any, unused: string, url?: string | URL | null | undefined) {
    window.history.pushState(data, unused, url)
}

function openModal(modalId: string, scrollToElementId?: string): void {
    openedModal.value = modalId
    ios26ModalCover.value = true
    modalOpenedOnRoute = route.name as string

    // The modal scrolls on its own backdrop, because Modal.vue locks body
    // scroll while it is open. It only exists once the teleport has rendered.
    nextTick(() => startView(modalId, document.querySelector<HTMLElement>('.backdrop') ?? window))

    if (scrollToElementId) {
        setTimeout(() => {
            const modal = document.querySelector('.modal-window')

            if (modal) {
                const titleEl = modal.querySelector(`#${scrollToElementId}`)
                if (titleEl) {
                    titleEl.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' })
                    scrollToElement.value = scrollToElementId
                }
            }
        }, 700)
    }
}

function closeModal(backToHomePage = true): void {
    ios26ModalCover.value = false
    openedModal.value = null
    scrollToElement.value = ''

    // Resumed rather than started, so returning from a modal does not count as
    // another view of the home page.
    if (backToHomePage) resumeView(HOME_PAGE_ID)
    else endView()
}

function switchModal(modalId: string, scrollToElementId?: string): void {
    closeModal(false)
    setTimeout(() => openModal(modalId, scrollToElementId), 300)
}

function onOpenModalClick(modalId: string, scrollToElementId?: string): void {
    pushState(null, '', `#${modalId}`)
    openModal(modalId, scrollToElementId)
}

function onSwitchModalClick(modalId: string, scrollToElementId?: string): void {
    closeModal(false)
    setTimeout(() => {
        pushState(null, '', `#${modalId}`)
        openModal(modalId, scrollToElementId)
    }, 300)
}

function onCloseModalClick(): void {
    const languageChanged = modalOpenedOnRoute && modalOpenedOnRoute !== route.name
    modalOpenedOnRoute = null

    if (languageChanged) {
        // Do not go back in history, because language will switch back:
        pushState(null, '', ' ')
        closeModal()
    } else {
        window.history.back()
    }
}

function onFlicked(): void {
    // Instantly close modal.
    // Disable modal transition (window's already closed):
    modalTransition.value = false
    onCloseModalClick()
    setTimeout(() => {
        modalTransition.value = true
    }, 0)
}

function modalDrag(dragCompletePercentage: number): void {
    mainPageModalCover.value!.style.transition = 'none'
    mainPageModalCover.value!.style.opacity = Math.min(1, 1 - dragCompletePercentage * 3).toString()
}

function modalDragRelease(willClose: boolean): void {
    mainPageModalCover.value!.style.transition = ''
    mainPageModalCover.value!.style.opacity = ''
    if (willClose) ios26ModalCover.value = false
}

function checkSecret(char?: string): void {
    secretSequence += char
    if (secretSequence === 'ABABAB') {
        window.location.href = '/admin'
    }
    clearTimeout(secretSequenceTimeout)
    secretSequenceTimeout = setTimeout(() => {
        secretSequence = ''
    }, 1500)
}

return (_ctx: any,_cache: any) => {
  const _component_card = _resolveComponent("card")!
  const _component_delimiter = _resolveComponent("delimiter")!
  const _component_main_page_title = _resolveComponent("main-page-title")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (adminData.value.outEnabled)
      ? (_openBlock(), _createBlock(ClosedBanner, {
          key: 0,
          "date-from": adminData.value.outStart,
          "date-to": adminData.value.outEnd
        }, null, 8, ["date-from", "date-to"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "main-page",
      onClick: _cache[10] || (_cache[10] = ($event: any) => (checkSecret()))
    }, [
      _createVNode(LanguageButtonStandalonePage, {
        "sticky-height": 640,
        align: "right"
      }),
      _createVNode(MainPageBanner),
      _createVNode(_Transition, {
        name: transitionName('block1')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_card, {
            class: "moto text-md",
            "hard-shadow": true
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "avatar-container" }, [
                _createElementVNode("div", { class: "avatar zoom-in" })
              ], -1)),
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (checkSecret('A')), ["stop"]))
              }, _toDisplayString(_ctx.$t('home.motto')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, mounted.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: transitionName('block2')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SocutnoLogo, {
            class: "mt-rem8",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (checkSecret('B')), ["stop"]))
          }, null, 512), [
            [_vShow, mounted.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: transitionName('block3')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "!mb-0" }, [
                _createElementVNode("b", null, "Urška Šavli")
              ], -1)),
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("small", null, _toDisplayString(_ctx.$t('home.doctorTitle')), 1)
              ])
            ]),
            _createVNode(_component_delimiter, { class: "mt-12 mb-14" })
          ], 512), [
            [_vShow, mounted.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: transitionName('block4')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_main_page_title, { class: "!mb-5" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('home.sections.booking')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(mapPinIcon),
              _createElementVNode("a", {
                target: "blank",
                href: "https://www.google.com/maps/place/Belokranjska+cesta+36,+8340+%C4%8Crnomelj/data=!4m2!3m1!1s0x47645b8ddd34238b:0xc5fe18b1ee4dbe9e?sa=X&ved=2ahUKEwie6PHp2u_-AhUMzKQKHZA0AGQQ8gF6BAgLEAI",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(trackClick)('maps')))
              }, " Belokranjska c. 36, Črnomelj ")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(phoneIcon),
              _createElementVNode("a", {
                href: `tel:${_unref(rawPhoneNumber)}`,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(trackClick)('phone')))
              }, [
                _createTextVNode(_toDisplayString(_unref(phoneNumber)), 1),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, null, -1))
              ], 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(mailIcon),
              _createElementVNode("a", {
                target: "_blank",
                href: "mailto:socutno.zobozdravstvo@gmail.com?subject=Naročilo na prvi pregled",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(trackClick)('email')))
              }, " socutno.zobozdravstvo@gmail.com ")
            ])
          ], 512), [
            [_vShow, mounted.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: transitionName('block5')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createVNode(ContactForm, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('home.contactForm.title')), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('home.contactForm.subtitle')), 1)
                ])
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, mounted.value]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_component_delimiter, { class: "my-14" }),
      _createVNode(_component_main_page_title, { class: "!mb-5" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('home.sections.workingHours')), 1)
        ]),
        _: 1
      }),
      _createVNode(WorkingHours),
      _createVNode(PhotoGallery, {
        class: "mt-4",
        ref_key: "galleryContainer",
        ref: galleryContainer,
        initialize: mountGallery.value
      }, null, 8, ["initialize"]),
      _createVNode(_component_delimiter, { class: "mt-16 mb-14" }),
      _createVNode(_component_main_page_title, { class: "mb-8 sm:mb-5" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('home.sections.team')), 1)
        ]),
        _: 1
      }),
      _createVNode(Ekipa),
      _createVNode(_component_a_button, {
        ref_key: "oNasButton",
        ref: oNasButton,
        color: "black",
        class: "mt-10 mx-auto text-sm px-8",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onOpenModalClick('o-nas')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('home.moreAboutUs')), 1)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_delimiter, { class: "my-14" }),
      _createVNode(_component_main_page_title, { class: "!mb-5" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('home.sections.services')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        ref_key: "servicesContainer",
        ref: servicesContainer
      }, [
        _createVNode(Services, {
          onSelect: _cache[6] || (_cache[6] = ($event: any) => (onOpenModalClick($event)))
        })
      ], 512),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { css: modalTransition.value }, {
          default: _withCtx(() => [
            (!!openedModal.value)
              ? (_openBlock(), _createBlock(Modal, {
                  key: 0,
                  onBackdropClick: onCloseModalClick,
                  onFlicked: onFlicked,
                  onDrag: _cache[7] || (_cache[7] = ($event: any) => (modalDrag($event))),
                  onDragStop: modalDragRelease
                }, {
                  default: _withCtx(() => [
                    (openedModal.value === 'pregledi')
                      ? (_openBlock(), _createBlock(Pregledi, {
                          key: 0,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'karies')
                      ? (_openBlock(), _createBlock(Karies, {
                          key: 1,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'ortopan')
                      ? (_openBlock(), _createBlock(Ortopan, {
                          key: 2,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'beljenje')
                      ? (_openBlock(), _createBlock(Beljenje, {
                          key: 3,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'parodontologija')
                      ? (_openBlock(), _createBlock(Parodontologija, {
                          key: 4,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'otrosko')
                      ? (_openBlock(), _createBlock(Otrosko, {
                          key: 5,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'myobrace')
                      ? (_openBlock(), _createBlock(Myobrace, {
                          key: 6,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'invisalign')
                      ? (_openBlock(), _createBlock(Invisalign, {
                          key: 7,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'endodontsko')
                      ? (_openBlock(), _createBlock(Endodontsko, {
                          key: 8,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'lasersko')
                      ? (_openBlock(), _createBlock(Lasersko, {
                          key: 9,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'frenulotomija')
                      ? (_openBlock(), _createBlock(Frenulotomija, {
                          key: 10,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'protetika')
                      ? (_openBlock(), _createBlock(Protetika, {
                          key: 11,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'injekcijska-tehnika')
                      ? (_openBlock(), _createBlock(InjekcijskaTehnika, {
                          key: 12,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'cenik')
                      ? (_openBlock(), _createBlock(Cenik, {
                          key: 13,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick,
                          marked: scrollToElement.value
                        }, null, 8, ["marked"]))
                      : _createCommentVNode("", true),
                    (openedModal.value === 'o-nas')
                      ? (_openBlock(), _createBlock(ONas, {
                          key: 14,
                          onClose: onCloseModalClick,
                          onNavigate: onSwitchModalClick
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["css"])
      ])),
      _createVNode(_component_a_button, {
        color: "black",
        class: "mt-9 mx-auto !pl-3",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (onOpenModalClick('cenik')))
      }, {
        default: _withCtx(() => [
          _createVNode(calculatorIcon),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('home.pricelist')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_delimiter, { class: "my-14" }),
      _createVNode(_component_main_page_title, null, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "black",
            href: "https://www.google.com/search?q=so%C4%8Dutno+Zobozdravstvo%2C+%C4%8Crnomelj&oq=so%C4%8Dutno+Zobozdravstvo%2C+%C4%8Crnomelj&gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQIxgnMgcIAhAAGIAEMgYIAxAAGB4yBggEEAAYHjIKCAUQABiABBiiBDIGCAYQRRhBMgYIBxBFGD3SAQgxNDAzajBqNKgCALACAQ&sourceid=chrome&ie=UTF-8#lrd=0x47645dd66f755653:0x195c4c6dba6eb5b3,1,,,,",
            target: "_blank",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(trackClick)('google_reviews')))
          }, _toDisplayString(_ctx.$t('home.sections.googleReviews')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        ref_key: "reviewsContainer",
        ref: reviewsContainer,
        class: "self-stretch flex justify-center"
      }, [
        _createVNode(_Transition, {
          name: transitionName('slide')
        }, {
          default: _withCtx(() => [
            (mountReviews.value)
              ? (_openBlock(), _createBlock(Reviews, {
                  key: 0,
                  "places-response": googlePlacesResponse.value,
                  locale: _unref(locale)
                }, null, 8, ["places-response", "locale"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["name"])
      ], 512),
      _createVNode(_component_delimiter, { class: "my-14 lg:mt-14" }),
      _createVNode(_component_main_page_title, { class: "!mt-0" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('home.sections.followUs')), 1)
        ]),
        _: 1
      }),
      _createVNode(SocialButtons),
      _createVNode(Footer),
      _createElementVNode("div", {
        ref_key: "mainPageModalCover",
        ref: mainPageModalCover,
        class: _normalizeClass(["ios-26-modal-cover", { 'modal-opened': ios26ModalCover.value }])
      }, null, 2)
    ], 512), [
      [_vShow, mounted.value]
    ])
  ], 64))
}
}

})